export default "/images/img_15.png?f6128e6ba18e015f4b9e24581ab2c9d8";